












	import {Vue, Component} from 'vue-property-decorator';

	@Component({})
    export default class SoftwareVideo extends Vue{
        goToVideo(){
         	window.location.href = "https://www.youtube.com/watch?v=vdwzLHDgIP0";
		}
	}
